<template lang="html">
  <div
    class="promo-price flex flex-col gap-1"
    :class="props.class"
  >
    <div class="flex flex-wrap items-baseline gap-2">
      <span
        v-if="showDiscount"
        class="text-sm text-muted line-through"
      >
        {{ $f.currency(basePrice) }}
      </span>
      <span
        class="font-bold"
        :class="showDiscount ? 'text-success' : ''"
      >
        {{ $f.currency(displayPrice) }}
      </span>
    </div>

    <span
      v-if="showLineTotal"
      class="text-sm font-medium text-muted"
    >
      Итого за {{ qty }} шт.: {{ $f.currency(lineTotal) }}
    </span>
  </div>
</template>

<script setup lang="ts">
import {
  getBasePrice,
  getCatalogPromoPrice,
  getEffectiveCatalogPrice,
  hasVisualDiscount,
  type PromoPriceSource,
} from '#Promotion/utils/promoPrice'

const props = withDefaults(
  defineProps<{
    value: PromoPriceSource
    /** Effective unit price override (e.g. after cart pricing). */
    unitPrice?: number | null
    /**
     * Cart line quantity. Unit price stays primary; when > 1, a secondary
     * line total is shown (PDP buy box).
     */
    quantity?: number
    class?: string
  }>(),
  {
    quantity: 1,
  },
)

const { $f } = useFormatter()

const qty = computed(() => Math.max(props.quantity ?? 1, 1))

const basePrice = computed(() => getBasePrice(props.value))
const catalogPromoPrice = computed(() => getCatalogPromoPrice(props.value))

const showDiscount = computed(() => {
  if (props.unitPrice != null) {
    return props.unitPrice < basePrice.value
  }

  return hasVisualDiscount(basePrice.value, catalogPromoPrice.value)
})

const displayPrice = computed(() => {
  if (props.unitPrice != null) {
    return props.unitPrice
  }

  return getEffectiveCatalogPrice(props.value)
})

const showLineTotal = computed(() => qty.value > 1)
const lineTotal = computed(() => displayPrice.value * qty.value)
</script>
